import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import siteData from '../data/site.json';
import { SiInstagram, SiLinkedin, SiThreads, SiGithub } from 'react-icons/si';

const socialIcons = {
  Instagram: SiInstagram,
  LinkedIn: SiLinkedin,
  Threads: SiThreads,
  Github: SiGithub,
};

const collaborations = [
  { title: 'AR Vinyl Enhancement with band Low Island x Blood Records', year: '2021' },
  { title: 'Mystery Bird AR effect with Quays Culture Manchester x artist Jack Hardiker', year: '2020' },
  { title: 'Nike SNS Instagram AR effects with AR creator Johanna Jaskowska', year: '2020' },
  { title: 'VR Empathy training for Greater Manchester Police with MM Productions', year: '2020' },
  { title: "Projection-Mapped Giant Puppet Head with Mel Roberts at Manchester International Festival '19", year: '2019' },
  { title: 'Dotted Mobile Game with artist Yoni Alter', year: '2017' },
];

const awards = [
  { title: 'Moth Hack 2026', subtitle: 'Winner, Challenge 7: Make a VST or AU - Quantum Variations', location: 'London', year: '2026' },
  { title: 'Meta Spark AR Hackathon', subtitle: 'Winning team member', location: 'Menlo Park, California', year: '2023' },
  { title: 'The Webby Awards', subtitle: 'Social Experimental & Innovation - Baby Blocker (Lead Developer)', year: '2020' },
  { title: 'Epica Awards', subtitle: 'Prescription and OTC Products (Gold), Health & Beauty (Silver) - Baby Blocker (Lead Developer)', year: '2019' },
  { title: 'Facebook AR Hackathon London', subtitle: 'Winning team member', year: '2019' },
  { title: 'Manchester International Festival', subtitle: 'Selected as a Creative Lab Artist', year: '2019' },
  { title: 'The Drum Roses Awards', subtitle: 'Online Advert or Campaign (Bronze) - Aldi #SaveKevin (AR Developer)', year: '2019' },
  { title: 'Facebook AR Hackathon Berlin', subtitle: 'Winning team member', year: '2018' },
  { title: "Mashable's 7 Essential Apps", subtitle: 'Dotted Game (Lead Developer)', year: '2017' },
  { title: 'The PM Society Digital Awards', subtitle: 'Multi-channel Campaign (Gold), Digital Patient Initiatives (Bronze), Innovation (Shortlisted) - The Trouble With Dragons App', year: '2016' },
  { title: 'Pharmaceutical Marketing Awards', subtitle: 'Craft Disease Awareness (Gold) - The Trouble With Dragons App', year: '2016' },
  { title: 'The FWA Awards', subtitle: 'Mobile App of the Day - The Trouble With Dragons App', year: '2015' },
];

const About = () => {
  return (
    <main className="main-wrapper">
      <div className="main-wrapper-left">
        <div className="about-hero-image-wrapper">
          <img loading="lazy" src="/images/headshots/JP2.2_BW@2x.webp" alt="About" className="about-hero-image" />
        </div>
      </div>
      <div className="main-wrapper-right">
        <section className="section-about-hero">
          <div className="about-about-left">
            <div className="about-about-profile">
              <img src="/images/headshots/JP2.1_BW.webp" loading="lazy" width="Auto" alt={siteData.name} className="border-radius-circle" />
              <div>
                <h1 className="heading-style-h5">{siteData.name}</h1>
                <div className="text-meta text-color-muted">{siteData.role}</div>
              </div>
            </div>
            <div className="max-width-medium">
              <div>{siteData.bio}</div>
            </div>
          </div>
          <div className="home-about-socials">
            {siteData.socials.map((social) => {
              const IconComponent = socialIcons[social.label];
              return (
                <a key={social.label} href={social.url} target="_blank" rel="noreferrer" className="social-card w-inline-block">
                  <div className="text-meta">{social.label}</div>
                  <div className="social-card-icon-wrapper">
                    <div className="social-card-icon w-embed">
                      {IconComponent ? <IconComponent /> : null}
                    </div>
                    <div className="social-card-icon-hover w-embed">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                        <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                      </svg>
                    </div>
                  </div>
                </a>
              );
            })}
            <Link to="/contact" className="social-card primary w-inline-block">
              <div className="text-meta text-color-inverse">Contact Me</div>
              <div className="social-card-icon-wrapper">
                <div className="social-card-icon w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M224,50H32a6,6,0,0,0-6,6V192a14,14,0,0,0,14,14H216a14,14,0,0,0,14-14V56A6,6,0,0,0,224,50Zm-96,85.86L47.42,62H208.58ZM101.67,128,38,186.36V69.64Zm8.88,8.14L124,148.42a6,6,0,0,0,8.1,0l13.4-12.28L208.58,194H47.43ZM154.33,128,218,69.64V186.36Z"></path>
                  </svg>
                </div>
                <div className="social-card-icon-hover w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                    <path d="M198,64V168a6,6,0,0,1-12,0V78.48L68.24,196.24a6,6,0,0,1-8.48-8.48L177.52,70H88a6,6,0,0,1,0-12H192A6,6,0,0,1,198,64Z"></path>
                  </svg>
                </div>
              </div>
            </Link>
          </div>
        </section>

        <section className="section-about-about">
          <h2 className="heading-style-h2">About</h2>
          <div>
            With a background spanning augmented reality, virtual reality, real-time graphics, and interactive installations,
            I specialise in building experiences that sit at the intersection of art and technology. Over the years, I've
            collaborated with artists, musicians, engineers, and creative directors on projects ranging from live events in
            the Metaverse to award-winning AR campaigns and projection-mapped parade puppets.
          </div>
          <div>
          Whether I'm developing crowd systems for a virtual Coldplay concert or bringing a vinyl record to life with AR,
          I bring the same dedication to craft, technical rigour, and collaborative spirit to every project.
          </div>
        </section>

        <section className="section-about-awards">
          <div className="about-exhibition-top">
            <h2 className="heading-style-h2">Awards</h2>
            <div className="max-width-medium">
              <div>Recognition for work in AR, game development, and interactive experiences.</div>
            </div>
          </div>
          {awards.map((item) => (
            <div key={item.title + item.year} className="awards-item" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'baseline' }}>
                <h3 className="heading-style-h5" style={{ margin: 0 }}>{item.title}</h3>
                <div className="text-meta">{item.year}</div>
              </div>
              <div className="text-meta text-color-muted" style={{ marginTop: '0.25rem' }}>{item.subtitle}</div>
            </div>
          ))}
        </section>

        <section className="section-about-awards">
          <div className="about-exhibition-top">
            <h2 className="heading-style-h2">Collaborations</h2>
            <div className="max-width-medium">
              <div>Creative partnerships across AR, VR, music, and interactive art.</div>
            </div>
          </div>
          {collaborations.map((item) => (
            <div key={item.title} className="awards-item" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'baseline' }}>
                <h3 className="heading-style-h5" style={{ margin: 0 }}>{item.title}</h3>
                <div className="text-meta">{item.year}</div>
              </div>
            </div>
          ))}
        </section>

        <Footer />
      </div>
    </main>
  );
};

export default About;

